import { branch, compose, withProps } from 'recompose';

import withDegreeAndMastertrackLists from 'bundles/browse/components/Domain/withDegreeAndMastertrackLists';
import type { WithDegreeAndMastertrackListsOutputProps } from 'bundles/browse/components/Domain/withDegreeAndMastertrackLists';
import { ProductVariantNames } from 'bundles/browse/constants';
import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';

type PropsFromCaller = {
  domainId?: string;
};

export type PropsToComponent = {
  degreeCollection: CarouselCollection;
  degreeListLoading: boolean;
};

export const toCarouselCollection = ({ degreeList }: WithDegreeAndMastertrackListsOutputProps) => {
  if (!degreeList) {
    return undefined;
  }

  const entities = degreeList.map((degree) => {
    return {
      id: degree.id,
      name: degree.name,
      slug: degree.slug,
      imageUrl: degree.thumbnailUrl || degree.imageUrl,
      link: degree.link,
      partners:
        degree.partners &&
        degree.partners.elements.map((partner) => {
          return {
            id: partner.id,
            logo: partner.logo,
            name: partner.name,
          };
        }),
      partnerLogos: degree.partners && degree.partners.elements.map((partner) => partner.logo),
      productType: degree.type,
    };
  });

  return {
    entities,
    collectionId: 'degree',
    title: '',
  } as CarouselCollection;
};

const withDegreeCollection = compose<PropsToComponent, PropsFromCaller>(
  branch(
    ({ domainId }: { domainId?: string }) => !!domainId,
    compose(
      withDegreeAndMastertrackLists<PropsFromCaller>(({ domainId }) => {
        const domains = [domainId || ''];
        const productVariants = [
          ProductVariantNames.BachelorsDegree,
          ProductVariantNames.MastersDegree,
          ProductVariantNames.PostgraduateDiploma,
        ];
        return { domains, productVariants };
      }),
      withProps(({ degreeList, degreeListLoading }: WithDegreeAndMastertrackListsOutputProps) => {
        return {
          degreeCollection: toCarouselCollection({ degreeList }),
          degreeListLoading,
        };
      })
    )
  )
);

export default withDegreeCollection;
